<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="采购商品明细" name="purchaseDetailSum">
        <search-form-template
          :searchOptions="purchaseDetailSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportDetailSumExport()"
        ></search-form-template>
        <table-template
          ref="purchaseDetailSum"
          :tableOptions="purchaseDetailTable"
        >
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="采购单据汇总" name="purchaseBillSum">
        <search-form-template
          :searchOptions="purchaseBillSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportBillsSumExport()"
        ></search-form-template>
        <table-template
          ref="purchaseBillSum"
          :tableOptions="purchaseBillTable"
        ></table-template>
      </el-tab-pane>
      <el-tab-pane label="采购供应商汇总" name="purchaseSupplierSum">
        <search-form-template
          :searchOptions="purchaseSupplierSumSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportSupplierSumExport()"
        ></search-form-template>
        <table-template
          ref="purchaseSupplierSum"
          :tableOptions="purchaseSupplierSumTable"
        ></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from "@/components/template/tableTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";
import axios from 'axios'

export default {
  mixins: [userPower],
  name: "RoleManager",
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: "purchaseDetailSum",
      loading: false,
      treeConfig: {
        id: "menuTree",
        showCheckbox: true,
        data: [],
        nodeKey: "id",
        defaultProps: {
          children: "children",
          label: "name",
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ""},
        },
      },
      // 采购明细汇总高级查询
      purchaseDetailSearchOptions: {
        simple: [
          {
            label: "条码",
            prop: "barCode",
            type: "input",
            isFuzzy: true,
            span: 6,
            labelWidth: '80px',
            placeholder: "请输入条码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            labelWidth: '80px',
            span: 24,
          },
          {
            label: "商品名称",
            prop: "goodsName",
            type: "input",
            isFuzzy: true,
            span: 6,
            labelWidth: '80px',
            placeholder: "请输入商品名称",
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            isHasAll: true,
            data: [],
            span: 6,
            labelWidth: '80px',
            change: this.storeDetailChange,
            url: api.system.seStore,
          },
          {
            label: "仓库名称",
            type: "select",
            prop: "warehouseId",
            span: 8,
            data: [],
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 6,
            labelWidth: '80px',
          },
          {
            label: "品牌",
            type: "select",
            prop: "goodsBrandId",
            data: [],
            labelWidth: '80px',
            span: 6
          },
          {
            label: '类别',
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            labelWidth: '80px',
            url: api.archives.getCategoryTree,
          },
          {
            label: "单号",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入单号",
          },
          {
            label: "单据类型",
            prop: "type",
            type: "select",
            span: 6,
            labelWidth: '80px',
            data: [
              {label: "采购收货单", value: 20},
              {label: "采购退货单", value: 30},
            ],
          },
        ],
      },
      // 采购单据汇总高级查询
      purchaseBillSearchOptions: {
        simple: [
          {
            label: "单号",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入单号",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            isHasAll: true,
            span: 6,
            change: this.storeOrderChange,
            url: api.system.seStore,
          },
          {
            label: "仓库名称",
            type: "select",
            prop: "warehouseId",
            span: 8,
            data: [],
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 6,
            labelWidth: '80',
          },
          {
            label: "单据类型",
            prop: "purchaseType",
            type: "select",
            span: 6,
            labelWidth: '80',
            data: [
              {label: "全部", value: undefined},
              {label: "采购收货单", value: 20},
              {label: "采购退货单", value: 30},
            ],
          },
        ],
      },
      // 采购供应商汇总高级查询
      purchaseSupplierSumSearchOptions: {
        simple: [
          {
            label: "供应商名称/编码",
            type: "input",
            prop: "supplierCode",
            isFuzzy: true,
            placeholder: "请输入供应商名称/编码",
          },
          // {
          //   label: "供应商名称",
          //   type: "input",
          //   prop: "supplierName",
          //   isFuzzy: true,
          //   placeholder: "请输入供应商名称",
          // },
        ],
        complex: [
          // {
          //   label: "采购级别",
          //   type: "select",
          //   prop: "relateType",
          //   data: this.$utils.getCacheStatus("pcPurchaseStorageOrder.relateType"),
          //   change: this.getSupplierSumChange,
          //   span: 12,
          //   hidden: true,
          // },
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            isHasAll: true,
            data: [],
            span: 12,
            change: this.storeSupChange,
            url: api.system.seStore,
          },
          {
            label: "仓库名称",
            type: "select",
            prop: "warehouseId",
            span: 8,
            data: [],
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 12,
            // url: api.archives.supplier,
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "打印",
          code: "print",
        },
        {
          label: "导出",
          code: "export",
          callback: this.exportExcel
        },
      ],
      //采购明细汇总
      purchaseDetailTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'giveGoodsNum', 'totalPrice'],
        param: {},
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "仓库名称",
            prop: "storeName",
            width: "150",
            align: "center",
          },
          {
            label: "单号",
            prop: "orderNo",
            width: "240",
            align: "center",
            callback: this.goOrderDetail
          },
          {
            label: "单据类型",
            prop: "type",
            width: "150",
            align: "center",
            enumData: this.$utils.getCacheStatus("pcGoodsMap.type"),
          },
          {
            label: "条码",
            prop: "barCode",
            width: "150",
            align: "center",
          },
          {
            label: "商品名称",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "150",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "70",
            align: "center",
          },
          {
            label: "数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveGoodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "单价",
            prop: "price",
            width: "100",
            align: "center",
          },
          {
            label: "金额",
            prop: "totalPrice",
            width: "100",
            align: "center",
          },
          {
            label: "供应商",
            prop: "supplierName",
            width: "120",
            align: "center",
          },
          {
            label: "类别",
            prop: "categoryName",
            width: "150",
            align: "center",
          },
          {
            label: "品牌",
            prop: "brandName",
            width: "150",
            align: "center",
          },
          {
            label: '制单人',
            prop: 'voucherName',
            width: '120',
            align: 'center',
          },
          {
            label: "备注",
            prop: "remarks",
            width: "125",
            align: "center",
          },
        ],
        url: api.purchase.detailSum,
      },
      //采购单据汇总
      purchaseBillTable: {
        showSummary: true,
        summaryColumns: ['orderAmt'],
        param: {},
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "仓库名称",
            prop: "storeName",
            width: "250",
            align: "center",
          },
          {
            label: "单号",
            prop: "orderNo",
            width: "250",
            align: "center",
            callback: this.goOrderDetail,
          },
          {
            label: "单据类型",
            prop: "purchaseType",
            width: "100",
            align: "center",
            enumData: this.$utils.getCacheStatus("pcGoodsMap.type"),
          },
          // {
          //   label: "供应商编码",
          //   prop: "supplierCode",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "供应商姓名",
            prop: "supplierName",
            width: "150",
            align: "center",
          },
          // {
          //   label: "经手人",
          //   prop: "handler",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "金额",
            prop: "orderAmt",
            width: "100",
            align: "center",
          },
          {
            label: "制单人",
            prop: "voucherName",
            width: "120",
            align: "center",
          },
          {
            label: "制单日期",
            prop: "voucherDttm",
            width: "150",
            align: "center",
          },
          {
            label: "审核人",
            prop: "reviewerName",
            width: "120",
            align: "center",
          },
          {
            label: "审核日期",
            prop: "reviewerDttm",
            width: "150",
            align: "center",
          },
          {
            label: "审核状态",
            prop: "reviewerStatus",
            width: "100",
            align: "center",
            enumData: this.$utils.getCacheStatus(
              "pcPurchaseReturnOrder.reviewerStatus"
            ),
          },
          // {
          //   label: "采购入库日期",
          //   prop: "goodsArriveDttm",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "备注",
            prop: "remarks",
            width: "125",
            align: "center",
          },
        ],
        url: api.purchase.billsSum,
      },
      //采购供应商汇总
      purchaseSupplierSumTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'totalPrice', 'giveNum', 'returnGoodsNum', 'returnTotalPrice', 'subTotalNum', 'subTotalAmt'],
        param: {},
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "仓库名称",
            prop: "storeName",
            width: "300",
            align: "center",
          },
          // {
          //   label: "供应商编码",
          //   prop: "supplierCode",
          //   width: "150",
          //   align: "center",
          // },
          {
            label: "供应商名称",
            prop: "supplierName",
            width: "150",
            align: "center",
          },
          {
            label: "采购数量",
            prop: "goodsNum",
            width: "150",
            align: "center",
          },
          {
            label: "金额",
            prop: "totalPrice",
            width: "150",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "150",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "returnGoodsNum",
            width: "150",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "returnTotalPrice",
            width: "150",
            align: "center",
          },
          {
            label: "小计数量",
            prop: "subTotalNum",
            width: "150",
            align: "center",
          },
          {
            label: "小计金额",
            prop: "subTotalAmt",
            width: "150",
            align: "center",
          },
        ],
        url: api.purchase.supplierSum,
      },

      stockDetailColumns:{
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png',
          },
          right: '200px',
          top: '30px',
        },
        span: 8,
        labelWidth: '130',
        columns: [
          {
            label: '业务单号',
            type: 'input',
            prop: 'orderNo',
          },
          {
            label: '采购门店',
            prop: 'storeName',
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierName',
          },
          {
            label: '门店仓库',
            type: 'select',
            prop: 'warehouseName',
          },
          {
            label: '经手人',
            prop: 'handler',
          },
          {
            label: '采购订单',
            prop: 'purchaseOrderNo',
          },
          {
            label: '来货日期',
            prop: 'goodsArriveDttm',
          },
          {
            label: '备注',
            prop: 'remarks',
          },
        ],
        tablesProp: {
          pcGoodsMapList: {
            url: api.purchase.goods + "/page",
            height: this.detailHeight,
            showSummary: true,
            indexShow: true,
            tableName: 'pcGoodsMapList',
            summaryColumns: ['goodsNum', 'giveGoodsNum', 'totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '150',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '90',
                align: 'center',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '60',
                align: 'center',
              },
              {
                label: '单位',
                width: '60',
                prop: 'unitName',
                align: 'center',
              },
              {
                label: '自编码',
                width: '120',
                prop: 'artNo',
                align: 'center',
              },
              // {
              //   label: '档案进价',
              //   width: '90',
              //   prop: 'buyPrice',
              //   align: 'center',
              // },
              {
                label: '实际入库数量',
                width: '130',
                prop: 'goodsNum',
                align: 'center',
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsNum',
                align: 'center',
              },
              {
                label: '进价',
                width: '120',
                prop: 'price',
                align: 'center',
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: 'center',
              },
              {
                label: '小计金额',
                width: '120',
                prop: 'totalPrice',
                align: 'center',
              },
              {
                label: '生产日期',
                prop: 'produceDttm',
                width: '220',
                align: 'center',
              },
              {
                label: '零售价',
                width: '120',
                prop: 'retailPrice',
                align: 'center',
              },
              {
                label: '零售金额',
                width: '90',
                prop: 'salesAmount',
                align: 'center',
              },
              {
                label: '采购未入库数量',
                width: '130',
                prop: 'noStorageNum',
                align: 'center',
              },
              {
                label: '系统库存',
                prop: 'inventoryNum',
                width: '90',
                align: 'center',
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '150',
                align: 'center',
              },
            ],
          },
        },
        // 打印的列表
        printTablesProp: {
          pcGoodsMapList: {
            tableName: 'pcGoodsMapList',
            showSummary: true,
            summaryColumns: ['totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '150',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '90',
                align: 'center',
              },
              // {
              //   label: '规格',
              //   prop: 'specs',
              //   width: '90',
              //   align: 'center',
              // },
              {
                label: '单位',
                width: '60',
                prop: 'unitName',
                align: 'center',
              },
              // {
              //   label: '自编码',
              //   width: '120',
              //   prop: 'artNo',
              //   align: 'center',
              // },
              {
                label: '零售价',
                width: '120',
                prop: 'retailPrice',
                align: 'center',
              },
              {
                label: '进货价',
                width: '90',
                prop: 'buyPrice',
                align: 'center',
              },
              {
                label: '实际入库数量',
                width: '130',
                prop: 'goodsNum',
                align: 'center',
              },
              {
                label: '采购未入库数量',
                width: '130',
                prop: 'noStorageNum',
                align: 'center',
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsNum',
                align: 'center',
              },
              {
                label: '小计金额',
                width: '120',
                prop: 'totalPrice',
                align: 'center',
              },
            ],
          },
        },
        url: api.purchase.stock,
      },
      returnDetailColumns:{
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '30px',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            type: 'input',
            prop: 'orderNo',
            disabled: true
          },
          {
            label: '采购门店',
            prop: 'storeName',
          }, {
            label: '供应商',
            type: 'select',
            prop: 'supplierName',
          }, {
            label: '仓库名称',
            type: 'select',
            prop: 'warehouseName',
          }, {
            label: '经手人',
            prop: 'handler',
            type: 'input',
          },
          {
            label: '采购入库单',
            type: 'select',
            prop: 'storageOrderNo',
            data: [],
            labelKey: 'orderNo',
          },
          {
            label: '备注',
            type: 'input',
            prop: 'remarks',
          }],
        tablesProp: {
          goodsMapList: {
            url: api.purchase.goods + "/page",
            height:this.detailHeight,
            showSummary:true,
            indexShow: true,
            tableName: "goodsMapList",
            summaryColumns: ['goodsNum', 'giveGoodsNum','totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '90',
                prop: 'artNo',
                align: "center"
              },
              // {
              //   label: '档案进价',
              //   prop: 'buyPrice',
              //   align: "center"
              // },
              {
                label: '数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                align: "center",
                change: this.numChange
              },
              {
                label: '赠送数量',
                prop: 'giveGoodsNum',
                type: 'input',
                align: "center"
              },
              {
                label: '进价',
                prop: 'price',
                type: 'input',
                align: "center",
                change: this.priceChange
              },
              {
                label: '小计金额',
                prop: 'totalPrice',
                type: 'input',
                align: "center"
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: "center"
              },
              {
                label: '零售金额',
                prop: 'salesAmount',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '150',
                align: "center"
              },
            ],
          }
        },
        // 打印的列表
        printTablesProp: {
          goodsMapList: {
            tableName: 'goodsMapList',
            showSummary: true,
            summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice', 'goodsNum'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '自编码',
                width: '90',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '零售价',
                width: '100',
                prop: 'retailPrice',
                align: "center"
              },
              {
                label: '零售金额',
                prop: 'salesAmount',
                align: "center"
              },
              {
                label: '进价',
                prop: 'buyPrice',
                align: "center"
              },
              {
                label: '退货数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                align: "center",
                change: this.numChange
              },
            ],
          },
        },
        url: api.purchase.return
      }
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.purchaseDetailSearchOptions.complex);
    this.setStore(this.purchaseBillSearchOptions.complex);
    this.setStore(this.purchaseSupplierSumSearchOptions.complex);
    let userInfo = this.$utils.getSysUser();
    if (userInfo.storeId) {
      this.storeDetailChange(userInfo)
      this.storeOrderChange(userInfo)
      this.storeSupChange(userInfo)
    }
  },
  mounted() {
  },
  methods: {
    storeDetailChange(form) {
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'warehouseId')[0].data = data.data;
        }
      });
    },
    storeOrderChange(form) {
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseBillSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseBillSearchOptions.complex.filter(item => item.prop === 'warehouseId')[0].data = data.data;
        }
      });
    },
    // 选择门店
    storeSupChange(form) {
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseSupplierSumSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.purchaseSupplierSumSearchOptions.complex.filter(item => item.prop === 'warehouseId')[0].data = data.data;
        }
      });
    },
    goOrderDetail(row) {
      if (row.purchaseType === undefined) {
        row.purchaseType = row.type;
      }
      if (row.purchaseType === 20) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.stockDetailColumns);
        const {href} = this.$router.resolve({
          name: "stockDetail",
          query: {id: row.purchaseId},
        });
        window.open(href, "_blank");
        // this.$router.push({path: '/purchase/stock/detail', query: {id: row.purchaseId}})
      } else {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
        const {href} = this.$router.resolve({
          name: "purchaseReturnDetail",
          query: {id: row.purchaseId},
        });
        window.open(href, "_blank");
      }
    },
    tabChange() {
      this.$refs[this.activeTab].operationSuccess();
    },
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    clearSearch() {
      this.$refs['purchaseDetailSum'].clearSearch();
      this.$refs['purchaseBillSum'].clearSearch();
      this.$refs['purchaseSupplierSum'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.purchaseSupplierSumSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.purchaseBillSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
      }
    },
    getDetailStoreChange(form) {
      if (form.relateType === 20) {
        this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = false;
      } else {
        this.purchaseDetailSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = true;
      }
    },
    getSupplierSumChange(form) {
      if (form.relateType === 20) {
        this.purchaseSupplierSumSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = false;
      } else {
        this.purchaseSupplierSumSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = true;
      }
    },
    getBillChange(form) {
      if (form.relateType === 20) {
        this.purchaseBillSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = false;
      } else {
        this.purchaseBillSearchOptions.complex.filter(item => item.prop === 'storeId')[0].hidden = true;
      }
    },
    exportDetailSumExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["purchaseDetailSum"].searchParam;
      this.$axios.PostBlob(api.purchase.detailSumExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '采购明细汇总_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },

    exportBillsSumExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["purchaseBillSum"].searchParam;
      this.$axios.PostBlob(api.purchase.billsSumExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '采购单据汇总_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },

    exportSupplierSumExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["purchaseSupplierSum"].searchParam;
      this.$axios.PostBlob(api.purchase.supplierSumExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '采购供应商汇总_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
  },
};
</script>

<style scoped>
.page-template {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/page/purchase/Query.vue